module.exports = __webpack_public_path__ + "img/default-crypto.c09801e2.svg";